import Quill from "quill"

// see: https://github.com/slab/quill/issues/1451#issuecomment-523559508
const AlignStyle = Quill.import("attributors/style/align")
Quill.register(AlignStyle, true)

const BackgroundStyle = Quill.import("attributors/style/background")
Quill.register(BackgroundStyle, true)

const ColorStyle = Quill.import("attributors/style/color")
Quill.register(ColorStyle, true)

const DirectionStyle = Quill.import("attributors/style/direction")
Quill.register(DirectionStyle, true)

const FontStyle = Quill.import("attributors/style/font")
Quill.register(FontStyle, true)

// Custom Indent Attributor

// based on https://github.com/slab/quill/blob/b1b4850f92240dafea2d96c635d39ab490f69527/packages/quill/src/formats/indent.ts
const { Scope, StyleAttributor } = Quill.import("parchment")

class IndentAttributor extends StyleAttributor {
  add(node, value) {
    if (value <= 0) {
      this.remove(node)
      return true
    }

    return super.add(node, `${value}em`)
  }

  canAdd(node, value) {
    return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10))
  }

  value(node) {
    return parseInt(super.value(node), 10)
  }
}

const IndentStyle = new IndentAttributor("indent", "text-indent", {
  scope: Scope.BLOCK,
})

Quill.register(IndentStyle, true)

// Custom Size Attributor
const sizes = { small: "10px", large: "18px", huge: "32px" }

class SizeAttributor extends StyleAttributor {
  add(node, value) {
    return super.add(node, sizes[value])
  }

  value(node) {
    return Object.keys(sizes).find((key) => sizes[key] === super.value(node))
  }
}

const SizeStyle = new SizeAttributor("size", "font-size", {
  scope: Scope.INLINE,
})

Quill.register(SizeStyle, true)
